<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-14 14:17:29
 * @LastEditors: guozhixion xiaoguo4072@163.com
 * @LastEditTime: 2022-05-09 16:37:23
 * @FilePath: /privacy-web/src/components/The/TheImage.vue
-->
<template>
  <!-- #0072f5 -->
  <div style="background: #123990">
    <div
      v-loading="loading"
      class="the-image"
      :class="{ 'the-image-mobile': isMobile }"
      @click="toLink(item.link)"
    >
      <img
        v-show="item.bannerImgVideo == 1"
        class="the-image-background"
        :src="item.icon"
        alt=""
      />
      <video
        ref="MaskVideo"
        v-show="item.bannerImgVideo == 2"
        class="the-image-background"
        :controls="false"
        :src="item.icon"
        x5-video-player-type="h5"
        playsinline
        webkit-playsinline="true"
        autoplay
        muted
        loop
      ></video>
      <div v-if="update" class="the-image-content animate__animated" :class="animated">
        <div class="the-image-content-title">{{ item.title }}</div>
        <div v-show="item.tips" class="the-image-content-tips">{{ item.tips }}</div>
        <div v-show="item.content" class="the-image-content-text">{{ item.content }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TheImage",
  props: {
    src: {
      type: Object,
      default: () => {},
    },
    animated: {
      type: String,
      default: "animate__zoomIn",
    },
  },
  data() {
    return {
      update: true,
      loading: false,
      item: {},
      first: false,
    };
  },
  created() {
    this.$nextTick(() => {
      let a = navigator.userAgent.toLowerCase();
      // console.log(11111, a);
      if (a.match(/MicroMessenger/i) == "micromessenger") {
        this.first = true;
        this.item.bannerImgVideo = 1;
        this.item.icon = require("@/assets/images/banner.gif");
        this.loading = true;
        let image = new Image();
        image.src = this.item.icon;
        image.onload = () => {
          this.loading = false;
        };
      }
    });
  },
  activated() {
    if (this.$refs.MaskVideo) this.$refs.MaskVideo.play();
  },
  deactivated() {
    if (this.$refs.MaskVideo) {
      this.$refs.MaskVideo.currentTime = 0;
      this.$refs.MaskVideo.pause();
    }
  },
  watch: {
    src: {
      handler(item) {
        if (this.first) {
          this.first = false;
          return;
        }
        this.item = { ...item };
        this.update = false;
        this.$nextTick(() => {
          this.update = true;
        });
        if (this.item.bannerImgVideo == 1) {
          this.loading = true;
          let image = new Image();
          let obj = { ...this.item };
          image.src = obj.icon;
          image.onload = () => {
            this.loading = false;
          };
        } else {
          this.loading = false;
          this.$nextTick(() => {
            this.$refs.MaskVideo.currentTime = 0;
            this.$refs.MaskVideo.play();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    toLink(link) {
      if (link) window.open(link, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.the-image {
  width: 100%;
  height: calc(100vh - $multiple * 50px);
  display: flex;
  cursor: pointer;
  position: relative;
  .the-image-background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0important;
    width: 100%;
    height: calc(100vh - $multiple * 50px);
    object-fit: cover;
  }
  .the-image-content {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    color: #fff;
    width: calc($multiple * 708px);
    margin: auto;
    font-family: PingFangSC-Regular, PingFang SC;
    z-index: 1;
    .the-image-content-title {
      font-size: calc($multiple * 38px);
      font-family: PingFangTC-Semibold, PingFangTC;
      font-weight: 600;
      color: #ffffff;
      line-height: calc($multiple * 38px);
      letter-spacing: calc($multiple * 3px);
      margin-bottom: calc($multiple * 26px);
    }
    .the-image-content-tips {
      font-size: calc($multiple * 20px);
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #ffffff;
      line-height: calc($multiple * 20px);
      letter-spacing: calc($multiple * 1px);
      margin-bottom: calc($multiple * 35px);
    }
    .the-image-content-text {
      font-size: calc($multiple * 14px);
      min-width: calc($multiple * 708px);
      line-height: calc($multiple * 20px);
      letter-spacing: calc($multiple * 1px);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
    }
  }
}
.the-image-mobile {
  width: 19.2rem;
  height: 14.85rem;
  .the-image-background {
    width: 19.2rem;
    height: 14.85rem;
  }
  .the-image-content {
    width: 15.31rem;
    .the-image-content-title {
      margin-top: 2.5rem;
      font-size: 1.02rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 1.43rem;
      letter-spacing: 0.05rem;
      margin-bottom: 0.36rem;
    }
    .the-image-content-tips {
      font-size: 0.72rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 1.02rem;
      margin-bottom: 0.77rem;
    }
    .the-image-content-text {
      font-size: 0.61rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      min-width: 15.31rem;
      color: #ffffff;
      line-height: 0.87rem;
    }
  }
}
</style>
